import { createRouter, createWebHistory } from "vue-router";

// 引入页面
import Login from "@/views/login.vue"
import Index from "@/views/index.vue"
import HomeManage from '@/views/home.vue'
import BaiKe from '@/views/baike.vue'
import Mall from '@/views/mall.vue'
import UserManage from '@/views/user.vue'
import AddPlant from '@/views/addPlant.vue'
import EditPlant from '@/views/editPlant.vue'
import MainLayout from '@/layouts/MainLayout.vue'



// 定义路由规则
const routes = [
    { path: "/login", component: Login },
    {
        path: '/',
        component: MainLayout, // 公共布局
        redirect: '/index',
        children: [
            { path: "/", component: MainLayout, redirect: "/index" },
            { path: "/index", component: Index },
            { path: '/home', component: HomeManage },
            { path: '/baike', component: BaiKe },
            { path: '/mall', component: Mall },
            { path: '/user', component: UserManage },
            { path: '/add_plant', component: AddPlant },
            { path: '/plants/update/:id', component: EditPlant }
        ]
    }
]

// 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem("token");

    if (to.path !== "/login" && !token) {
        // 没 token 但想访问首页，跳转登录页
        next("/login");
    } else {
        next(); // 允许进入
    }
});

// 导出路由对象
export default router;





















